export default "__VITE_ASSET__1fd36b68__"